<nav class="navbar navbar-expand-lg text-white fixed-top" style="z-index: 9999 !important; background-color: rgba(0, 0, 0, 0.65) !important;">
    <span (click)="openSideBarLeft()" aria-expanded="false" aria-label="Toggle navigation" id="menu-toggle">
      <i class="far fa-envelope fa-2x brand-color"></i>
    </span>
    <a class="navbar-brand text-center">
      <img src="../../assets/brand.svg" width="140" alt="">
    </a>
    <span (click)="openSideBarRight()" aria-expanded="false" aria-label="Toggle navigation" id="menu-toggle">
      <i class="fas fa-bars fa-2x brand-color"></i>
    </span>
  </nav>
  
  <div #sideBarLeft class="sideBarLeft font-brand" style="z-index: 10000 !important;">
    <span class="closebtn" (click)="closeSideBarLeft()">
      <i class="far fa-envelope fa-2x text-white"></i>
    </span>
    <div class="row">
      <div class="col-10 offset-1">
        <form class="mt-4 text-center" style="opacity: 1.0 !important;" [formGroup]="form" #contactForm="ngForm" (ngSubmit)="send(contactForm)">
          <small class="text-danger" style="text-align: left;"
            *ngIf="controlIsRequired('name') && contactForm.submitted"
          >
            (Nombre requerido)
          </small>
          <input 
            type="text" 
            placeholder="Tu nombre"
            formControlName="name"
            [ngClass]="{ 'is-invalid': controlIsInvalid('name') && contactForm.submitted }"
            class="form-control mb-3 form-control-lg border-dark" 
            style="background: linear-gradient(180deg, rgba(103, 82, 236, 0.5) 0%, rgba(125, 100, 236, 0.41) 100%); border-radius: 15px; color: white;"
          >

          <small class="text-danger ml-2"
            *ngIf="controlIsRequired('email') && contactForm.submitted"
          >
            (Correo requerido)
          </small>
          <small class="text-danger ml-2"
            *ngIf="controlIsInvalidEmail('email') && contactForm.submitted"
          >
            (Correo inválido)
          </small>
          <input 
            type="text" 
            placeholder="Tu email"
            formControlName="email" 
            [ngClass]="{ 'is-invalid': controlIsInvalid('email') && contactForm.submitted }"
            class="form-control mb-3 form-control-lg border-dark" 
            style="background: linear-gradient(180deg, rgba(103, 82, 236, 0.5) 0%, rgba(125, 100, 236, 0.41) 100%); border-radius: 15px; color: white;"
          >

          <small class="text-danger ml-2"
            *ngIf="controlIsRequired('message') && contactForm.submitted"
          >
            (Mensaje requerido)
          </small>
          <textarea 
            type="text"
            placeholder="Mensaje"
            formControlName="message" 
            [ngClass]="{ 'is-invalid': controlIsInvalid('message') && contactForm.submitted }"
            rows="10" 
            class="form-control border-dark"
            style="background: linear-gradient(180deg, rgba(103, 82, 236, 0.5) 0%, rgba(125, 100, 236, 0.41) 100%); border-radius: 15px; color: white;"
          ></textarea>
          <button 
            class="btn btn-lg px-4 mt-4" 
            type="submit" 
            style="font-size: 13px; font-weight: 500; background-color: #7371FC !important; border-radius: 0.99rem!important; color: white;"
          >
            HAZ TU COTIZACIÓN
          </button>
        </form>
      </div>
    </div>
  </div>
  
  <div #sideBarRight class="sideBarRight font-brand" style="z-index: 10000 !important;">
    <span class="closebtn" (click)="closeSideBarRight()" >
      <i class="fas fa-bars fa-2x text-white"></i>
    </span>
    <a href="#">HOME</a>
    
    <a class="my-3 pb-0" data-toggle="collapse" href="#collapseServices" role="button" aria-expanded="false" aria-controls="collapseServices" (click)="setServicesCollapse()">
      <i class="fas brand-color mr-1" [ngClass]="{ 'fa-angle-down': !collapseServices, 'fa-angle-up': collapseServices  }"></i>
      SERVICIOS
    </a>
    <div class="collapse" id="collapseServices">
      <a href="#" style="color: #29EBC8;">SEGURIDAD INFORMÁTICA</a>
      <a href="#" style="color: #29EBC8;">PÁGINAS Y APP WEB</a>
      <a href="#" style="color: #29EBC8;">APLICACIONES MÓVILES</a>
      <a href="#" style="color: #29EBC8;">COMERCIO ELECTRÓNICO</a>
      <a href="#" style="color: #29EBC8;">ARQUITECTURA DE DATOS</a>
      <a href="#" style="color: #29EBC8;">CIENCIA DE DATOS</a>
      <a href="#" style="color: #29EBC8;">DISPOSITIVOS IOT</a>
    </div>

    <a href="#" data-toggle="collapse" href="#collapseProjects" role="button" aria-expanded="false" aria-controls="collapseProjects" (click)="setProjectCollapse()">
      <i class="fas brand-color mr-1" [ngClass]="{ 'fa-angle-down': !collapseProjects, 'fa-angle-up': collapseProjects  }"></i>
      PROYECTOS
    </a>
    <div class="collapse" id="collapseProjects">
      <a href="#" style="color: #29EBC8;">PRACTIFY</a>
      <a href="#" style="color: #29EBC8;">BLYKE</a>
      <a href="#" style="color: #29EBC8;">GEOGROW</a>
    </div>

    <!-- <a href="#" class="mt-3 mb-2">CONTACTO</a> 
    <div class="row">
      <div class="col-12">
        <div class="btn-group">
          <a href="#" type="button">
            <img src="../../../../../assets/instagram.svg" alt="" width="30">
          </a>
          <a href="#" type="button" style="padding: 7px !important;">
            <img src="../../../../../assets/whatsapp.svg" alt="" width="30">
          </a>
          <a href="#" type="button" style="padding: 6px !important;">
            <img src="../../../../../assets/linkedin.svg" alt="" width="30">
          </a>
        </div>
      </div>
    </div>-->
  </div>